import { SkeletonSpinnerCentered } from '@civilgrid/ui/SkeletonLoader';
import { useParams } from '@tanstack/react-router';
import { cloneDeep } from 'lodash';
import { useAsyncRetry } from 'react-use';
import { useSnapshot } from 'valtio';
import { getCivilSearchActivities as apiGetActivities } from '~/api/projects2';
import { Prefs } from '~/common/prefs';
import EmailLink from '~/components2/EmailLink';
import type { ProjectDetailsParams } from '~/pages/projectDetails';
import rootStore from '~/store';
import store from '../../store';
import Drawer, { DrawerContainer, DrawerContent } from '../Drawer';
import ActivityList from './ActivityList';

export default function ActivityFeed() {
  const { me } = useSnapshot(rootStore) as typeof rootStore;
  const { projectId } = useParams({ strict: false }) as ProjectDetailsParams;

  const activities = useAsyncRetry(async () => {
    const res = await apiGetActivities(projectId);
    const forward = res?.sort((a, b) => {
      return a.createdAt.toMillis() - b.createdAt.toMillis();
    });

    const backward = cloneDeep(forward).reverse();
    const id = backward?.find((a) => a.user?.id !== me?.id)?.id;
    if (id) {
      store.setLastViewed(Prefs.LAST_VIEWED_ACTIVITY_ID, 'activity', id);
    }

    return forward;
  }, [projectId]);

  if (activities.loading) {
    return (
      <Drawer title="Activity Feed" tooltip="Full history of all the records research activity on this project.">
        <DrawerContainer>
          <SkeletonSpinnerCentered />
        </DrawerContainer>
      </Drawer>
    );
  }

  if (activities.error || !activities.value) {
    return (
      <Drawer title="Activity Feed" tooltip="Full history of all the records research activity on this project.">
        <div>
          En error occurred while fetching messages, please <EmailLink>contact support</EmailLink>.
        </div>
      </Drawer>
    );
  }

  return (
    <Drawer title="Activity Feed" tooltip="Full history of all the records research activity on this project.">
      <DrawerContainer>
        <DrawerContent className="relative w-full">
          <ActivityList activities={activities.value} />
        </DrawerContent>
      </DrawerContainer>
    </Drawer>
  );
}
